import rawDashboardTabsTemplate from 'scoreboard/dashboards/display/dashboards-tabs.hbs'
import _ from 'lodash'

var strategyMapsTabsTemplate = function (context) {
	var wrappedContext = _.cloneDeep(context)
	return rawDashboardTabsTemplate({
		...wrappedContext,
		section: 'strategy-maps',
	})
}

export default strategyMapsTabsTemplate

strategyMapsTabsTemplate.__filename__ = 'strategy-maps/strategy-maps-tabs-template.js'
